import { loadAnomaliesForBlock } from './slices';

const loadAnomaliesForBlocks = (blockIds) => (dispatch) => {
  if (blockIds && blockIds.length) {
    blockIds.forEach((blockId) => dispatch(loadAnomaliesForBlock(blockId)));
  }
};

export {
  loadAnomaliesForBlock,
  loadAnomaliesForBlocks,
};
